export default __webpack_public_path__ + "static/media/play-and-pause-button.4d0d50e5.png";